import * as React from 'react';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import TaxonomyLocationEvent from './Event';
import TaxonomyLocationProject from './Project';
import { TaxonomyLocation } from '../../../types/uncinc_profile/taxonomy';


type ThemeViewmode = 'event' | 'project';
interface LocationProps extends React.ComponentPropsWithoutRef<'span'> {
  entity: ImmutableEntity<TaxonomyLocation>;
  viewMode: ThemeViewmode;
}

const TaxonomyTheme: React.FC<LocationProps> = ({ entity, viewMode }) => {
  switch (viewMode) {
    case 'event':
      return <TaxonomyLocationEvent entity={entity} />;
    case 'project':
    default:
      return <TaxonomyLocationProject entity={entity} />;
  }
};

export default TaxonomyTheme;
